// extracted by mini-css-extract-plugin
export default {"wrapper":"TranscriptPage_wrapper__epCQZ","contentWrapper":"TranscriptPage_contentWrapper__B1J6Q"};